/**
 * 出金リクエストに関する定数
 */
export const WithdrawalRequestConstants = {
  // 最低出金額
  MIN_WITHDRAWAL_AMOUNT: 4000,
  // 最短振込完了日数（営業日）
  MIN_DAYS_TO_PROCESS: 3,
  // 報酬有効期限（年）
  REWARD_VALIDITY_YEARS: 1,
}
